@if (templatePage === 'CartPageTemplate') {
  <section>
    <app-standard-cart></app-standard-cart>
  </section>
}
@if (templatePage === 'CheckoutPageTemplate') {
  <section>
    <app-standard-cart-checkout></app-standard-cart-checkout>
  </section>
}
